import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquircleZoomRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30 16c0 1.497-.12 2.965-.35 4.397a11.2 11.2 0 0 1-9.253 9.253 27.7 27.7 0 0 1-8.793 0 11.2 11.2 0 0 1-9.254-9.253 27.7 27.7 0 0 1 0-8.793 11.2 11.2 0 0 1 9.254-9.254 27.7 27.7 0 0 1 8.793 0 11.2 11.2 0 0 1 9.253 9.254c.23 1.43.35 2.899.35 4.396",
			fill: "url(#squircle-zoom-regular-icon)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.904 20.277H6.976c-.487 0-.92-.29-1.107-.739a1.19 1.19 0 0 1 .26-1.305l4.8-4.8h-3.44a1.71 1.71 0 0 1-1.712-1.71h6.39a1.196 1.196 0 0 1 .847 2.044l-4.8 4.8h3.98a1.71 1.71 0 0 1 1.71 1.71m12.32-5.346a3.34 3.34 0 0 0-3.337-3.337c-.984 0-1.87.429-2.481 1.109a3.33 3.33 0 0 0-2.48-1.109 3.34 3.34 0 0 0-3.337 3.337v5.346a1.71 1.71 0 0 0 1.71-1.71V14.93c0-.897.73-1.626 1.626-1.626s1.625.73 1.625 1.626v3.635c0 .945.767 1.711 1.712 1.711V14.93c0-.897.729-1.626 1.625-1.626s1.625.73 1.625 1.626v3.635a1.71 1.71 0 0 0 1.711 1.711z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "squircle-zoom-regular-icon",
			x1: 8.626,
			y1: 28.771,
			x2: 23.373,
			y2: 3.229,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#0845bf" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .6,
					stopColor: "#0b5cff"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4f90ee"
				})
			]
		}) })
	]
});
export default SvgSquircleZoomRegularIcon;
